import React from 'react';

export default function FeaturedEmployers(){
  const employers = [
    { id: 'e1', name: 'Acme Tech', desc: 'Innovative software company', logoColor: '#3060A0' },
    { id: 'e2', name: 'DataWorks', desc: 'Analytics and insights', logoColor: '#4070A0' },
    { id: 'e3', name: 'HealthCo', desc: 'Healthcare services', logoColor: '#105090' },
    { id: 'e4', name: 'FinServe', desc: 'Financial services', logoColor: '#3060A0' }
  ];

  return (
    <section className="py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-2xl font-bold mb-4">Featured Employers</h3>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {employers.map(e => (
            <div key={e.id} className="min-w-[220px] bg-white rounded-lg p-4 shadow flex items-start gap-3">
              <div style={{background:e.logoColor}} className="w-12 h-12 rounded flex items-center justify-center text-white font-bold">{e.name.split(' ').map(s=>s[0]).slice(0,2).join('')}</div>
              <div>
                <div className="font-semibold">{e.name}</div>
                <div className="text-sm text-gray-600">{e.desc}</div>
                <div className="mt-3"><button className="text-sm text-primary-deep font-semibold">View Jobs</button></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
